import { lazy } from "react";

const Login = lazy(() => import("./Login"));
const MagicLinkVerification = lazy(() => import("./MagicLinkVerification"));

export { Login, MagicLinkVerification };
